import AvatarStudioCore from "@/components/AvatarStudioCore";
import { Card } from "@/components/ui/card";
import { useAuth } from "@/contexts/AuthContext";

export default function AvatarStudio() {
  const { user, refresh } = useAuth();
  return (
    <Card className="rounded-3xl p-6 border-2" data-testid="avatar-studio">
      <AvatarStudioCore
        endpoints={{
          put: "/client/avatar",
          aiGenerate: "/client/avatar/ai-generate",
          aiEdit: "/client/avatar/ai-edit",
        }}
        currentUrl={user?.avatar_url || ""}
        seedName={user?.full_name || "Friend"}
        onChange={() => refresh()}
      />
    </Card>
  );
}
